import { createVanIconComponent } from "./van"

const Font = createVanIconComponent("font")
export default Font
